var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 7h6.5M7 11h4m-4 4h3m0 6H5a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2v4m-3.134 3.27l-2.789 4.875a.573.573 0 00-.009.558.541.541 0 00.466.288h2.61v2.451a.545.545 0 00.388.537.525.525 0 00.602-.25l2.789-4.871a.573.573 0 00.009-.56.541.541 0 00-.466-.287h-2.61v-2.45a.545.545 0 00-.386-.54.525.525 0 00-.604.25z",
    stroke: "currentColor",
    strokeWidth: 1.499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDocumentFlash;